
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11907',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11907",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.456",
  "dashboard-client-types": "static-1.313",
  "data-fetching-client": "static-1.9569",
  "foundations-components": "static-1.7709",
  "foundations-components-legacy": "static-1.734",
  "foundations-theming": "static-1.4306",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7905",
  "hub-http-shared-msw-handlers": "static-1.9717",
  "hubspot-dlb": "static-2.1828",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11345",
  "I18n": "static-7.1600",
  "jasmine-runner": "static-1.6363",
  "marketplace-storefront-base": "static-1.11968",
  "quartz": "static-1.6860",
  "react-dlb": "static-1.76",
  "react-rhumb": "static-1.16548",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2756",
  "reporting-testing-lib": "static-1.8928",
  "settings-ui-lib": "static-1.12419",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6940",
  "ui-addon-i18n": "static-1.11041",
  "ui-addon-react-router-dom": "static-1.9438",
  "unified-auth": "static-1.340",
  "unified-auth-core-lib": "static-1.621",
  "usage-tracker": "static-1.7230",
  "usage-tracker-core": "static-1.7080",
  "customer-data-property-utils": "static-1.7977",
  "history": "static-4.47",
  "hub-http": "static-1.6112",
  "integrations-lib": "static-1.15764",
  "marketplace-ui-common": "static-1.19284",
  "property-management-iframe": "static-1.12788",
  "quartz-config": "static-1.638",
  "quartz-core": "static-1.6079",
  "quartz-routing": "static-1.290",
  "quick-fetch": "static-1.3828",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4537",
  "ts-schema": "static-1.3991",
  "ui-universal-auth": "static-1.8826",
  "UIComponents": "static-3.8292",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3319",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3137",
  "quartz-webpack": "static-1.3084",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3978",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4740",
  "foundations-theming-specialty": "static-1.2022",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9323",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5261",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1516",
  "ui-fonts": "static-1.607",
  "ui-images": "static-2.1127",
  "bend-plugin-foundations-theming": "static-1.2789",
  "foundations-theming-base": "static-1.3291",
  "stylex": "static-1.30",
  "HeadJS": "static-2.734",
  "hs-test-utils-bend-plugin": "static-1.3016",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4218",
  "ai-components-ui-library": "static-1.8666",
  "ai-rendering-library": "static-1.9687",
  "chirp-fetch": "static-1.1775",
  "connections-embed-lib": "static-1.784",
  "copilot-toolkit": "static-1.10829",
  "laboratory-lib": "static-3.7053",
  "marketplace-embed": "static-1.21773",
  "marketplace-ui-details": "static-1.9180",
  "marketplace-ui-reviews": "static-1.19240",
  "marketplace-ui-tracking": "static-1.13455",
  "sanitize-text": "static-1.8038",
  "ui-addon-video-player": "static-1.8590",
  "usage-tracker-multi": "static-1.5644",
  "usage-tracker-session-replay": "static-1.4916",
  "wootric-nps": "static-1.6878",
  "apollo-link-hub-http": "static-2.4544",
  "immer": "static-1.33",
  "immerable": "static-1.4047",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2427",
  "reporting-data": "static-1.66995",
  "cssUtils": "static-1.766",
  "flux-actions": "static-1.325",
  "HubStyle": "static-2.11653",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10103",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10267",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7220",
  "icons": "static-2.639",
  "marketplace-ui-apps-core": "static-1.17817",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4413",
  "foundations-components-test-utils": "static-1.5192",
  "quartz-i18n": "static-1.535",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3627",
  "customer-data-objects": "static-1.7550",
  "property-translator": "static-1.5302",
  "frontend-preferences-client": "static-1.7818",
  "hs-promise-utils": "static-1.5488",
  "hubspot-apollo-client": "static-1.4772",
  "integrations-error-boundary-lib": "static-1.13179",
  "integrations-tracking-lib": "static-1.5489",
  "native-integrations-shared-strings": "static-1.7680",
  "reselect": "static-2.16",
  "sanitize": "static-1.4366",
  "superstore": "static-1.4663",
  "ui-shepherd-react": "static-3.10041",
  "ai-settings-ui-library": "static-1.7712",
  "hub-http-janus": "static-1.818",
  "hubspotter-http": "static-1.4565",
  "immutable-less": "static-1.4547",
  "marketplace-ui-client-types": "static-1.16691",
  "nav-meta": "static-1.29268",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10139",
  "ui-addon-upgrades": "static-9.17829",
  "inbound-db-properties-service-client": "static-1.3759",
  "property-management-common": "static-1.5076",
  "ui-addon-iframeable": "static-1.8943",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.535",
  "quartz-head": "static-1.525",
  "quartz-test": "static-1.535",
  "quartz-tracking": "static-1.239",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3057",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20786",
  "ContentUtils": "static-1.68019",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2387",
  "customer-data-filters-ui": "static-1.39323",
  "customer-data-objects-ui-components": "static-1.12912",
  "customer-data-reference-ui-components": "static-1.13047",
  "embedded-academy-lib": "static-1.13936",
  "ExportDialog": "static-6.10284",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40960",
  "reporting-snowflake": "static-1.55613",
  "reporting-ui-components": "static-2.64266",
  "reporting-visualizations": "static-1.59071",
  "ui-addon-teams": "static-1.21400",
  "magpie-lib": "static-1.5487",
  "magpie-types": "static-1.4947",
  "simple-logging-lib": "static-1.2945",
  "navigation-components": "static-1.17631",
  "ai-studio-lib": "static-1.11294",
  "app-governance-lib": "static-1.1215",
  "developer-experience-shared-components": "static-1.10400",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7885",
  "ui-product-approvals": "static-1.27830",
  "ui-tool-access": "static-1.10040",
  "usage-based-billing-components-lib": "static-1.8312",
  "usage-tracker-anonymous": "static-1.5647",
  "usage-tracker-public": "static-1.7041",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3502",
  "persist-promise": "static-1.3602",
  "reference-resolvers": "static-1.8060",
  "ui-extensibility-client-types": "static-1.3833",
  "hubspot-apollo-cache": "static-1.231",
  "universal-page-editor-lib": "static-1.2900",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2474",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4964",
  "purchase-motions-components": "static-1.5669",
  "salesImages": "static-1.523",
  "batch-promise": "static-1.1445",
  "crm-component-utils": "static-1.38774",
  "crm-properties-common-lib": "static-1.5768",
  "customer-data-properties": "static-1.51163",
  "framework-data-schema-resolvers": "static-1.6769",
  "property-value-citations": "static-1.1777",
  "reference-resolvers-lite": "static-1.7983",
  "navigation-messaging": "static-1.6958",
  "hubspotter-http-shared-msw-handlers": "static-1.9715",
  "cms-field-types": "static-1.4703",
  "content-icons-ui": "static-1.2198",
  "conversations-skeleton-state": "static-1.7143",
  "crm-message-bus": "static-1.42684",
  "customer-data-filters-ui-msw-helpers": "static-1.21758",
  "customer-data-ui-utilities": "static-1.9719",
  "FormUrlGenerator": "static-2.4613",
  "framework-builder-read-service-client": "static-1.3921",
  "framework-data-schema-quick-fetch": "static-1.6674",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16406",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13367",
  "academy-common-lib": "static-1.13396",
  "content-assistance-lib": "static-1.7592",
  "dashboard-lib": "static-1.81077",
  "file-manager-components": "static-1.23277",
  "getting-started-shared-tasks": "static-1.18192",
  "hubspot-prosemirror": "static-1.17925",
  "hubspot-prosemirror-plugins": "static-1.17917",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19647",
  "share-with-third-party-component-lib": "static-1.8588",
  "ui-addon-draggable": "static-3.4663",
  "ui-asset-management-lib": "static-1.10868",
  "ui-business-units-lib": "static-1.8934",
  "user-context": "static-1.4993",
  "growth-payments-core": "static-1.25044",
  "reporting-plugins": "static-1.10127",
  "reporting-reports": "static-1.66673",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.618",
  "nest": "static-1.115",
  "codemirror": "static-5.93",
  "feedback-loader": "static-1.29098",
  "react-codemirror": "static-1.10517",
  "framework-listing-lib": "static-2.28357",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30424",
  "apps-service-types": "static-1.3771",
  "oauth-service-types": "static-1.4142",
  "onboarding-scopes": "static-1.6357",
  "onboarding-tours-client": "static-1.4620",
  "platform-infra-nav-components": "static-1.7579",
  "subscription-experience-data-types": "static-1.14722",
  "crm-record-cards-service-types": "static-1.3523",
  "location-customization-utils-lib": "static-1.8901",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4395",
  "nav-client-types": "static-1.2252",
  "purchase-motions-api": "static-1.5672",
  "signup-constants": "static-1.18643",
  "signup-ui-url-generator": "static-2.7933",
  "trials-service-types": "static-1.3796",
  "card-properties-lib": "static-1.43846",
  "commerce-subscription-lib": "static-1.36782",
  "crm-actions": "static-1.6208",
  "crm-cards-sdk": "static-1.43252",
  "customer-data-properties-shared-msw-handlers": "static-1.9044",
  "customer-data-tracking": "static-1.6777",
  "hs-resources": "static-1.31",
  "pulse": "static-1.431",
  "calling-global-api": "static-1.64089",
  "calling-internal-common": "static-1.31195",
  "calling-lifecycle-internal": "static-1.65471",
  "calling-lifecycle-messages": "static-1.57765",
  "commerce-products-lib": "static-1.9137",
  "conditional-properties-service-client": "static-1.3710",
  "crm-links": "static-1.6169",
  "external-options-client-types": "static-1.4071",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4136",
  "meetings-icalendar-utils-lib": "static-1.524",
  "multi-currency-client-types": "static-1.3602",
  "object-builder-ui-client": "static-1.48377",
  "pipeline-validation-client-types": "static-1.3878",
  "smart-property-lib": "static-1.6413",
  "tiered-pricing": "static-1.1001",
  "ui-addon-form-validation": "static-1.10885",
  "crm-pipelines-api-client-types": "static-1.4055",
  "react-dnd-compat": "static-1.4512",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5265",
  "growth-onboarding-confetti": "static-1.2965",
  "growth-onboarding-next-action-utils": "static-1.1599",
  "onboarding-tours-utils": "static-1.472",
  "ui-shepherd-tracker": "static-1.7422",
  "academy-service-client": "static-1.3574",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28239",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8276",
  "video-components-external": "static-1.10926",
  "video-data-lib": "static-1.34584",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23225",
  "ui-addon-emoji-picker": "static-1.9781",
  "EmailSignatureEditor": "static-1.24139",
  "viral-links-lib": "static-1.6932",
  "data-token-picker": "static-1.16218",
  "FileManagerLib": "static-1.38917",
  "react-flip-move": "static-1.68",
  "timezone-utils": "static-2.5138",
  "getting-started-shared-tasks-store": "static-1.17310",
  "campaign-roi-lib": "static-1.8620",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7217",
  "customer-data-views-management": "static-1.25212",
  "framework-data-table": "static-2.11663",
  "marketing-platform-lib": "static-1.6743",
  "nudge-client-utils": "static-1.2348",
  "nudge-custom-ui-functions": "static-1.840",
  "app-users-service-client": "static-1.5450",
  "app-users-service-types": "static-1.4858",
  "mini-checkout-client": "static-1.26551",
  "onboarding-utils": "static-1.5245",
  "permissions-shared-i18n-strings-fe": "static-1.2000",
  "ui-coaching-tips-shared-config": "static-1.28224",
  "edison-service-client-types": "static-1.281",
  "eligibility-engine-service-types": "static-1.3077",
  "crm_data": "static-4.91608",
  "customer-data-sidebar": "static-2.45706",
  "enrichment-properties-lib": "static-1.15531",
  "commerce-billing-lib": "static-1.18781",
  "commerce-shared-components-lib": "static-1.18248",
  "commerce-tools-ui-lib": "static-1.10092",
  "crm-fe-perf": "static-1.22796",
  "directed-graph": "static-1.831",
  "event-emitter": "static-1.842",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31201",
  "shared-worker-versioning": "static-1.10932",
  "calling-usage-tracker": "static-1.6435",
  "voice-sms-access-library": "static-1.581",
  "commerce-permissions": "static-1.659",
  "products-iframe-lib": "static-1.7627",
  "products-ui-components-shared-msw-handlers": "static-1.10099",
  "data-agent-kit": "static-1.22",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9800",
  "policy-lib": "static-1.6676",
  "react-tinymce": "static-1.54928",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9863",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54054",
  "tinymce-plugins": "static-1.57168",
  "tinymce-themes": "static-1.56024",
  "onboarding-data-sync-lib": "static-1.1781",
  "growth-onboarding-next-action-components": "static-1.1627",
  "user-context-client": "static-1.4505",
  "growth-onboarding-feedback-components": "static-1.6475",
  "content-media-composition-data-lib": "static-1.11881",
  "content-media-compositions": "static-2.15888",
  "media-bridge-lib": "static-1.18738",
  "commerce-tours-lib": "static-1.5897",
  "growth-onboarding-reliability": "static-1.4980",
  "sales-checkout-service-client": "static-1.3562",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21487",
  "sales-email-signature-service-client": "static-1.3737",
  "audio-components": "static-1.5755",
  "FileManagerCore": "static-1.38776",
  "FileManagerImages": "static-1.36428",
  "video-components": "static-1.12929",
  "crm-export-dialog": "static-1.6189",
  "crm-index-associations-lib": "static-1.6329",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1628",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2105",
  "nudge-renderer-utils": "static-1.2424",
  "whisper-core-api": "static-1.6287",
  "InboxConnectUtils": "static-4.14513",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5274",
  "settings-content-modals": "static-1.45770",
  "crm_universal": "static-1.21820",
  "customer-data-email": "static-1.17848",
  "card-payment-highlight-lib": "static-1.36834",
  "card-subscription-highlight-lib": "static-1.39205",
  "commerce-contract-lib": "static-1.11581",
  "invoices-highlight-card-lib": "static-1.54360",
  "orders-highlight-card-lib": "static-1.21154",
  "products-highlight-card-lib": "static-1.17421",
  "quotes-highlight-card-lib": "static-1.71579",
  "breeze-intelligence-kit": "static-1.5466",
  "crm-source-interpretation-lib": "static-1.5228",
  "utility-belt": "static-1.2433",
  "payments-enrollment-embed-lib": "static-1.22322",
  "stripe-embedded-components": "static-1.7317",
  "customer-data-rte": "static-1.32717",
  "cv-backend-services": "static-1.1537",
  "growth-onboarding-empty-states": "static-1.5522",
  "payments-post-enroll-local-storage-lib": "static-1.5005",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37669",
  "calling-orchestration-schema": "static-1.35358",
  "sales-views-client-types": "static-1.4157",
  "hub-http-contrib": "static-1.2937",
  "interframe": "static-3.4657",
  "tinymce-data": "static-1.40139",
  "ui-addon-sales-email": "static-1.5105",
  "layout-dnd-components": "static-1.12238",
  "layout-dnd-utils": "static-1.11213",
  "ui-brand-identity-lib": "static-1.14758",
  "NamespacedHubStyle": "static-2.8981",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4425",
  "video-embed": "static-1.35418",
  "social-insights-client-types": "static-1.21760",
  "deal-intel-utils": "static-1.1632",
  "checkout-sdk": "static-3.23394",
  "checkout-service-types": "static-1.3740",
  "company-details-components": "static-1.6079",
  "payment-method-components": "static-1.6790",
  "pricing-pages-ui-components": "static-1.13235",
  "quote-checkout-service-types": "static-1.3368",
  "upgrade-catalog-service-types": "static-1.3420",
  "access-control-lib": "static-1.10332",
  "EmailComponents": "static-1.54456",
  "EmailData": "static-1.53133",
  "redux-less": "static-2.9378",
  "sequences-lib": "static-1.7857",
  "ui-gdpr-components": "static-1.10242",
  "products-ui-components": "static-1.39656",
  "quotes-ui-lib": "static-1.80300",
  "accounting-integrations-ui-components": "static-1.6890",
  "invoices-ui-lib": "static-1.54376",
  "commerce-products-api": "static-1.2127",
  "invoices-iframe-lib": "static-1.56434",
  "quotes-modal-lib": "static-1.102257",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27985",
  "ContentData": "static-1.68094",
  "layout-data-lib": "static-1.9538",
  "outpost": "static-1.4088",
  "hub-http-rxjs": "static-1.784",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3824",
  "billing-payments-client-types": "static-1.3883",
  "account-and-billing-fintech-outages": "static-3.18376",
  "pricing-pages-api": "static-1.13100",
  "ContentComponents": "static-2.70975",
  "marketing-contacts-lib": "static-1.9505",
  "marketing-email-service-types": "static-1.1837",
  "messaging-editing-lib": "static-1.45929",
  "messaging-usage-based-billing-components-lib": "static-1.791",
  "automation-ui-source-apps": "static-1.18551",
  "automation-ui-types": "static-1.19469",
  "messaging-types-lib": "static-1.45666",
  "onboarding-settings-client": "static-1.4397",
  "sequences-client-types-lib": "static-1.7714",
  "commerce-tax-lib": "static-1.413",
  "property-description-translator": "static-1.3747",
  "SalesContentIndexUI": "static-3.9074",
  "commerce-analytics-service-client": "static-1.3550",
  "totals-ui-components": "static-1.23272",
  "advanced-menus-core": "static-1.14961",
  "advanced-menus-lib": "static-1.11924",
  "ui-memberships-settings-lib": "static-1.33745",
  "demographics-service-types": "static-1.1545",
  "automation-ui-ubb": "static-1.5385",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7234",
  "data-token-views": "static-1.16199",
  "forms-utils-lib": "static-1.12378",
  "payments-embed-points-lib": "static-1.12819",
  "simple-menus-core": "static-1.14960",
  "simple-menus-lib": "static-1.16477",
  "ui-addon-draggable-compat": "static-2.4148",
  "videoconference-integration-components": "static-1.6666",
  "automation-applications-service-types": "static-1.3415",
  "automation-platform-service-types": "static-1.2551",
  "ContentEditorUI": "static-2.76797",
  "short-messages-app-service-client": "static-1.3877",
  "web-interactives-components": "static-1.13577",
  "web-interactives-data": "static-1.13578",
  "messaging-shared-utils-lib": "static-1.240",
  "messaging-user-info-utils-lib": "static-1.410",
  "email-portal-health-service-types": "static-1.870",
  "FireAlarmUi": "static-1.4423",
  "sales-templates-service-types-lib": "static-1.4079",
  "commerce-totals-service-types": "static-1.3730",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21405",
  "automation-ui-usage-tracking": "static-1.20868",
  "data-studio-ubb": "static-1.2411",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26714",
  "collaboration-sidebar": "static-1.57459",
  "content-management-data-lib": "static-1.5250",
  "copilot-plugins": "static-1.10802",
  "cta-picker": "static-1.36119",
  "customer-agent-discovery-components-lib": "static-1.2750",
  "editor-components": "static-1.13075",
  "editor-iframe-lib": "static-1.8254",
  "error-messaging-js": "static-1.5085",
  "FormsCommonComponents": "static-1.85562",
  "pictos": "static-7.182",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10540",
  "SharedLegalStrings": "static-1.1645",
  "smart-content-core": "static-1.42147",
  "smart-content-lib": "static-1.42800",
  "social-composer-lib": "static-1.58547",
  "structured-content-lib": "static-1.24903",
  "theme-previewer-lib": "static-1.52957",
  "tinymce-copilot": "static-1.16122",
  "xray-recommendation-lib": "static-1.7750",
  "automation-ui-routing": "static-1.20826",
  "sql-reporting-client-types": "static-1.5554",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41918",
  "campaigns-utils-lib": "static-1.3052",
  "reporting-enablement": "static-1.22488",
  "chatspot-widget-iframe": "static-1.20778",
  "collaboration-sidebar-common": "static-1.2256",
  "forms-ai-lib": "static-1.4151",
  "codemirror-dlb": "static-1.58356",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6322",
  "report-customization-components": "static-1.12820",
  "data-quality-ui-library": "static-1.12591",
  "html-to-image": "static-1.52",
  "reporting-insights-lib": "static-1.1399"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11907",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.456",
  "dashboard-client-types": "/dashboard-client-types/static-1.313",
  "data-fetching-client": "/data-fetching-client/static-1.9569",
  "foundations-components": "/foundations-components/static-1.7709",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.734",
  "foundations-theming": "/foundations-theming/static-1.4306",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7905",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9717",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11345",
  "I18n": "/I18n/static-7.1600",
  "jasmine-runner": "/jasmine-runner/static-1.6363",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11968",
  "quartz": "/quartz/static-1.6860",
  "react-dlb": "/react-dlb/static-1.76",
  "react-rhumb": "/react-rhumb/static-1.16548",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2756",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8928",
  "settings-ui-lib": "/settings-ui-lib/static-1.12419",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6940",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11041",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9438",
  "unified-auth": "/unified-auth/static-1.340",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.621",
  "usage-tracker": "/usage-tracker/static-1.7230",
  "usage-tracker-core": "/usage-tracker-core/static-1.7080",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7977",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6112",
  "integrations-lib": "/integrations-lib/static-1.15764",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19284",
  "property-management-iframe": "/property-management-iframe/static-1.12788",
  "quartz-config": "/quartz-config/static-1.638",
  "quartz-core": "/quartz-core/static-1.6079",
  "quartz-routing": "/quartz-routing/static-1.290",
  "quick-fetch": "/quick-fetch/static-1.3828",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4537",
  "ts-schema": "/ts-schema/static-1.3991",
  "ui-universal-auth": "/ui-universal-auth/static-1.8826",
  "UIComponents": "/UIComponents/static-3.8292",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3319",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3137",
  "quartz-webpack": "/quartz-webpack/static-1.3084",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3978",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4740",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2022",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9323",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5261",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1516",
  "ui-fonts": "/ui-fonts/static-1.607",
  "ui-images": "/ui-images/static-2.1127",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2789",
  "foundations-theming-base": "/foundations-theming-base/static-1.3291",
  "stylex": "/stylex/static-1.30",
  "HeadJS": "/HeadJS/static-2.734",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3016",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4218",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8666",
  "ai-rendering-library": "/ai-rendering-library/static-1.9687",
  "chirp-fetch": "/chirp-fetch/static-1.1775",
  "connections-embed-lib": "/connections-embed-lib/static-1.784",
  "copilot-toolkit": "/copilot-toolkit/static-1.10829",
  "laboratory-lib": "/laboratory-lib/static-3.7053",
  "marketplace-embed": "/marketplace-embed/static-1.21773",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9180",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19240",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13455",
  "sanitize-text": "/sanitize-text/static-1.8038",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8590",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5644",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4916",
  "wootric-nps": "/wootric-nps/static-1.6878",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4544",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4047",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "reporting-data": "/reporting-data/static-1.66995",
  "cssUtils": "/cssUtils/static-1.766",
  "flux-actions": "/flux-actions/static-1.325",
  "HubStyle": "/HubStyle/static-2.11653",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10103",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10267",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7220",
  "icons": "/icons/static-2.639",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17817",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4413",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5192",
  "quartz-i18n": "/quartz-i18n/static-1.535",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3627",
  "customer-data-objects": "/customer-data-objects/static-1.7550",
  "property-translator": "/property-translator/static-1.5302",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7818",
  "hs-promise-utils": "/hs-promise-utils/static-1.5488",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4772",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13179",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5489",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7680",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4366",
  "superstore": "/superstore/static-1.4663",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10041",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7712",
  "hub-http-janus": "/hub-http-janus/static-1.818",
  "hubspotter-http": "/hubspotter-http/static-1.4565",
  "immutable-less": "/immutable-less/static-1.4547",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16691",
  "nav-meta": "/nav-meta/static-1.29268",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10139",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17829",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3759",
  "property-management-common": "/property-management-common/static-1.5076",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8943",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.535",
  "quartz-head": "/quartz-head/static-1.525",
  "quartz-test": "/quartz-test/static-1.535",
  "quartz-tracking": "/quartz-tracking/static-1.239",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20786",
  "ContentUtils": "/ContentUtils/static-1.68019",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2387",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39323",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12912",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13047",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13936",
  "ExportDialog": "/ExportDialog/static-6.10284",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40960",
  "reporting-snowflake": "/reporting-snowflake/static-1.55613",
  "reporting-ui-components": "/reporting-ui-components/static-2.64266",
  "reporting-visualizations": "/reporting-visualizations/static-1.59071",
  "ui-addon-teams": "/ui-addon-teams/static-1.21400",
  "magpie-lib": "/magpie-lib/static-1.5487",
  "magpie-types": "/magpie-types/static-1.4947",
  "simple-logging-lib": "/simple-logging-lib/static-1.2945",
  "navigation-components": "/navigation-components/static-1.17631",
  "ai-studio-lib": "/ai-studio-lib/static-1.11294",
  "app-governance-lib": "/app-governance-lib/static-1.1215",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10400",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7885",
  "ui-product-approvals": "/ui-product-approvals/static-1.27830",
  "ui-tool-access": "/ui-tool-access/static-1.10040",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8312",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5647",
  "usage-tracker-public": "/usage-tracker-public/static-1.7041",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3502",
  "persist-promise": "/persist-promise/static-1.3602",
  "reference-resolvers": "/reference-resolvers/static-1.8060",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3833",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.231",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2900",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2474",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4964",
  "purchase-motions-components": "/purchase-motions-components/static-1.5669",
  "salesImages": "/salesImages/static-1.523",
  "batch-promise": "/batch-promise/static-1.1445",
  "crm-component-utils": "/crm-component-utils/static-1.38774",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5768",
  "customer-data-properties": "/customer-data-properties/static-1.51163",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6769",
  "property-value-citations": "/property-value-citations/static-1.1777",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7983",
  "navigation-messaging": "/navigation-messaging/static-1.6958",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9715",
  "cms-field-types": "/cms-field-types/static-1.4703",
  "content-icons-ui": "/content-icons-ui/static-1.2198",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7143",
  "crm-message-bus": "/crm-message-bus/static-1.42684",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21758",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9719",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4613",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3921",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6674",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16406",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13367",
  "academy-common-lib": "/academy-common-lib/static-1.13396",
  "content-assistance-lib": "/content-assistance-lib/static-1.7592",
  "dashboard-lib": "/dashboard-lib/static-1.81077",
  "file-manager-components": "/file-manager-components/static-1.23277",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18192",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17925",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17917",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19647",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8588",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4663",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10868",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8934",
  "user-context": "/user-context/static-1.4993",
  "growth-payments-core": "/growth-payments-core/static-1.25044",
  "reporting-plugins": "/reporting-plugins/static-1.10127",
  "reporting-reports": "/reporting-reports/static-1.66673",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.618",
  "nest": "/nest/static-1.115",
  "codemirror": "/codemirror/static-5.93",
  "feedback-loader": "/feedback-loader/static-1.29098",
  "react-codemirror": "/react-codemirror/static-1.10517",
  "framework-listing-lib": "/framework-listing-lib/static-2.28357",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30424",
  "apps-service-types": "/apps-service-types/static-1.3771",
  "oauth-service-types": "/oauth-service-types/static-1.4142",
  "onboarding-scopes": "/onboarding-scopes/static-1.6357",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4620",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7579",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14722",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3523",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8901",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4395",
  "nav-client-types": "/nav-client-types/static-1.2252",
  "purchase-motions-api": "/purchase-motions-api/static-1.5672",
  "signup-constants": "/signup-constants/static-1.18643",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7933",
  "trials-service-types": "/trials-service-types/static-1.3796",
  "card-properties-lib": "/card-properties-lib/static-1.43846",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36782",
  "crm-actions": "/crm-actions/static-1.6208",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43252",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9044",
  "customer-data-tracking": "/customer-data-tracking/static-1.6777",
  "hs-resources": "/hs-resources/static-1.31",
  "pulse": "/pulse/static-1.431",
  "calling-global-api": "/calling-global-api/static-1.64089",
  "calling-internal-common": "/calling-internal-common/static-1.31195",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65471",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57765",
  "commerce-products-lib": "/commerce-products-lib/static-1.9137",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3710",
  "crm-links": "/crm-links/static-1.6169",
  "external-options-client-types": "/external-options-client-types/static-1.4071",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4136",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.524",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3602",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48377",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3878",
  "smart-property-lib": "/smart-property-lib/static-1.6413",
  "tiered-pricing": "/tiered-pricing/static-1.1001",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10885",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4055",
  "react-dnd-compat": "/react-dnd-compat/static-1.4512",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5265",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2965",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1599",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.472",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7422",
  "academy-service-client": "/academy-service-client/static-1.3574",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28239",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8276",
  "video-components-external": "/video-components-external/static-1.10926",
  "video-data-lib": "/video-data-lib/static-1.34584",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23225",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9781",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24139",
  "viral-links-lib": "/viral-links-lib/static-1.6932",
  "data-token-picker": "/data-token-picker/static-1.16218",
  "FileManagerLib": "/FileManagerLib/static-1.38917",
  "react-flip-move": "/react-flip-move/static-1.68",
  "timezone-utils": "/timezone-utils/static-2.5138",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17310",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8620",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7217",
  "customer-data-views-management": "/customer-data-views-management/static-1.25212",
  "framework-data-table": "/framework-data-table/static-2.11663",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6743",
  "nudge-client-utils": "/nudge-client-utils/static-1.2348",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.840",
  "app-users-service-client": "/app-users-service-client/static-1.5450",
  "app-users-service-types": "/app-users-service-types/static-1.4858",
  "mini-checkout-client": "/mini-checkout-client/static-1.26551",
  "onboarding-utils": "/onboarding-utils/static-1.5245",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2000",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28224",
  "edison-service-client-types": "/edison-service-client-types/static-1.281",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3077",
  "crm_data": "/crm_data/static-4.91608",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45706",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15531",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18781",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18248",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10092",
  "crm-fe-perf": "/crm-fe-perf/static-1.22796",
  "directed-graph": "/directed-graph/static-1.831",
  "event-emitter": "/event-emitter/static-1.842",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31201",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10932",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6435",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.581",
  "commerce-permissions": "/commerce-permissions/static-1.659",
  "products-iframe-lib": "/products-iframe-lib/static-1.7627",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10099",
  "data-agent-kit": "/data-agent-kit/static-1.22",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9800",
  "policy-lib": "/policy-lib/static-1.6676",
  "react-tinymce": "/react-tinymce/static-1.54928",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9863",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54054",
  "tinymce-plugins": "/tinymce-plugins/static-1.57168",
  "tinymce-themes": "/tinymce-themes/static-1.56024",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1781",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1627",
  "user-context-client": "/user-context-client/static-1.4505",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6475",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11881",
  "content-media-compositions": "/content-media-compositions/static-2.15888",
  "media-bridge-lib": "/media-bridge-lib/static-1.18738",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5897",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4980",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3562",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21487",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3737",
  "audio-components": "/audio-components/static-1.5755",
  "FileManagerCore": "/FileManagerCore/static-1.38776",
  "FileManagerImages": "/FileManagerImages/static-1.36428",
  "video-components": "/video-components/static-1.12929",
  "crm-export-dialog": "/crm-export-dialog/static-1.6189",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6329",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1628",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2105",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2424",
  "whisper-core-api": "/whisper-core-api/static-1.6287",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14513",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5274",
  "settings-content-modals": "/settings-content-modals/static-1.45770",
  "crm_universal": "/crm_universal/static-1.21820",
  "customer-data-email": "/customer-data-email/static-1.17848",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36834",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39205",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11581",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54360",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21154",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17421",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71579",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5466",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5228",
  "utility-belt": "/utility-belt/static-1.2433",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22322",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7317",
  "customer-data-rte": "/customer-data-rte/static-1.32717",
  "cv-backend-services": "/cv-backend-services/static-1.1537",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5522",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5005",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37669",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35358",
  "sales-views-client-types": "/sales-views-client-types/static-1.4157",
  "hub-http-contrib": "/hub-http-contrib/static-1.2937",
  "interframe": "/interframe/static-3.4657",
  "tinymce-data": "/tinymce-data/static-1.40139",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5105",
  "layout-dnd-components": "/layout-dnd-components/static-1.12238",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11213",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14758",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8981",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4425",
  "video-embed": "/video-embed/static-1.35418",
  "social-insights-client-types": "/social-insights-client-types/static-1.21760",
  "deal-intel-utils": "/deal-intel-utils/static-1.1632",
  "checkout-sdk": "/checkout-sdk/static-3.23394",
  "checkout-service-types": "/checkout-service-types/static-1.3740",
  "company-details-components": "/company-details-components/static-1.6079",
  "payment-method-components": "/payment-method-components/static-1.6790",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13235",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3368",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3420",
  "access-control-lib": "/access-control-lib/static-1.10332",
  "EmailComponents": "/EmailComponents/static-1.54456",
  "EmailData": "/EmailData/static-1.53133",
  "redux-less": "/redux-less/static-2.9378",
  "sequences-lib": "/sequences-lib/static-1.7857",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10242",
  "products-ui-components": "/products-ui-components/static-1.39656",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80300",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6890",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54376",
  "commerce-products-api": "/commerce-products-api/static-1.2127",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56434",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102257",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27985",
  "ContentData": "/ContentData/static-1.68094",
  "layout-data-lib": "/layout-data-lib/static-1.9538",
  "outpost": "/outpost/static-1.4088",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.784",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3824",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3883",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18376",
  "pricing-pages-api": "/pricing-pages-api/static-1.13100",
  "ContentComponents": "/ContentComponents/static-2.70975",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9505",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1837",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45929",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.791",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18551",
  "automation-ui-types": "/automation-ui-types/static-1.19469",
  "messaging-types-lib": "/messaging-types-lib/static-1.45666",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4397",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7714",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.413",
  "property-description-translator": "/property-description-translator/static-1.3747",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9074",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3550",
  "totals-ui-components": "/totals-ui-components/static-1.23272",
  "advanced-menus-core": "/advanced-menus-core/static-1.14961",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11924",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33745",
  "demographics-service-types": "/demographics-service-types/static-1.1545",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5385",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7234",
  "data-token-views": "/data-token-views/static-1.16199",
  "forms-utils-lib": "/forms-utils-lib/static-1.12378",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12819",
  "simple-menus-core": "/simple-menus-core/static-1.14960",
  "simple-menus-lib": "/simple-menus-lib/static-1.16477",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4148",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6666",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3415",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2551",
  "ContentEditorUI": "/ContentEditorUI/static-2.76797",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3877",
  "web-interactives-components": "/web-interactives-components/static-1.13577",
  "web-interactives-data": "/web-interactives-data/static-1.13578",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.240",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.410",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.870",
  "FireAlarmUi": "/FireAlarmUi/static-1.4423",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4079",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3730",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21405",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20868",
  "data-studio-ubb": "/data-studio-ubb/static-1.2411",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26714",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57459",
  "content-management-data-lib": "/content-management-data-lib/static-1.5250",
  "copilot-plugins": "/copilot-plugins/static-1.10802",
  "cta-picker": "/cta-picker/static-1.36119",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2750",
  "editor-components": "/editor-components/static-1.13075",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8254",
  "error-messaging-js": "/error-messaging-js/static-1.5085",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85562",
  "pictos": "/pictos/static-7.182",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10540",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1645",
  "smart-content-core": "/smart-content-core/static-1.42147",
  "smart-content-lib": "/smart-content-lib/static-1.42800",
  "social-composer-lib": "/social-composer-lib/static-1.58547",
  "structured-content-lib": "/structured-content-lib/static-1.24903",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52957",
  "tinymce-copilot": "/tinymce-copilot/static-1.16122",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7750",
  "automation-ui-routing": "/automation-ui-routing/static-1.20826",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5554",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41918",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3052",
  "reporting-enablement": "/reporting-enablement/static-1.22488",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20778",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2256",
  "forms-ai-lib": "/forms-ai-lib/static-1.4151",
  "codemirror-dlb": "/codemirror-dlb/static-1.58356",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6322",
  "report-customization-components": "/report-customization-components/static-1.12820",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12591",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1399"
}
};
